"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AffiliateProgramStatus = void 0;
var AffiliateProgramStatus;
(function (AffiliateProgramStatus) {
    /**
     * Enabled affiliate program, users can create new accounts using this affiliate program
     */
    AffiliateProgramStatus[AffiliateProgramStatus["Enabled"] = 0] = "Enabled";
    /**
     * Disabled affiliate program, users can't to create new accounts using this affiliate program.
     * Accumulating to compensate the affiliate program user still works for the affiliate program owner.
     */
    AffiliateProgramStatus[AffiliateProgramStatus["Disabled"] = 1] = "Disabled";
})(AffiliateProgramStatus = exports.AffiliateProgramStatus || (exports.AffiliateProgramStatus = {}));
//# sourceMappingURL=affiliate-program-status.js.map